/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
query RateReadQuery($type: CUSTOMER_TYPE!, $take: PositiveInt, $skip: Int) {
  RateRead(type: $type, take: $take, skip: $skip) {
    id,
    displayName,
    type,
    message
    status
  }
}
`
